const initialState = {
  externalEncounterId: "",
  externalEncounterTitle: "",
};

const EnlivReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_EXTERNAL_ENCOUNTER_INFO":
      return {
        ...state,
        externalEncounterId: action.payload.externalEncounterId,
        externalEncounterTitle: action.payload.externalEncounterTitle,
      };
    default:
      return state;
  }
};

export default EnlivReducer;
